module.exports = __webpack_public_path__ + "media/images/athletes/1319-cc3b82da2bee563588b624a73dfada12.png";